import NetteForms from 'nette-forms';

type FormError = { element: HTMLElement; message: string };

const ITEM_SELECTOR = '.contact-form__item, .contact-form__checkbox';

/**
 * Contact and inquiry forms: validation errors next to the fields instead of
 * the default alert(), and a loading state while Naja sends the form.
 */
export default class FormSubmission {
    static init(): void {
        NetteForms.showFormErrors = FormSubmission.showErrors;
        _naja.formsHandler.netteForms = NetteForms;

        document.addEventListener('input', FormSubmission.clearError);
        document.addEventListener('change', FormSubmission.clearError);

        let submitButton: HTMLElement | null = null;

        _naja.uiHandler.addEventListener('interaction', (event) => {
            const element = event.detail.element as HTMLElement & { form?: HTMLFormElement | null };
            const form = element instanceof HTMLFormElement ? element : element.form;
            submitButton = form?.querySelector<HTMLElement>('button[type="submit"]') ?? null;
        });

        _naja.addEventListener('start', () => {
            submitButton?.classList.add('is-loading');
        });

        _naja.addEventListener('complete', () => {
            if (!submitButton) {
                return;
            }

            submitButton.classList.remove('is-loading');
            submitButton = null;
            document.querySelector('.form-sent')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }

    static showErrors(form: HTMLFormElement, errors: FormError[]): void {
        form.querySelectorAll('.form-error').forEach((error) => error.remove());
        form.querySelectorAll('.is-invalid').forEach((item) => item.classList.remove('is-invalid'));

        errors.forEach(({ element, message }) => {
            const item = element.closest(ITEM_SELECTOR);
            if (!item || item.classList.contains('is-invalid')) {
                return;
            }

            const error = document.createElement('p');
            error.className = 'form-error';
            error.textContent = message;
            item.classList.add('is-invalid');
            item.appendChild(error);
        });

        const first = errors[0]?.element;
        if (first) {
            // the inquiry form spans two steps, show the one with the error
            const step = first.closest<HTMLElement>('[data-inquiry-content]');
            if (step && !step.classList.contains('is-active')) {
                document.querySelector<HTMLElement>(`[data-inquiry-link="${step.dataset.inquiryContent}"]`)?.click();
            }

            first.focus({ preventScroll: true });
            first.closest(ITEM_SELECTOR)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    private static clearError(event: Event): void {
        const item = (event.target as HTMLElement).closest?.(ITEM_SELECTOR);
        if (item?.classList.contains('is-invalid')) {
            item.classList.remove('is-invalid');
            item.querySelector('.form-error')?.remove();
        }
    }
}
